var _path, _g, _path2, _path3, _mask, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturnLocationMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 48,
    viewBox: "0 0 34 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9846 43L9.4934 35.3944C1.05417 26.9109 1 21.6387 1 17.1727C1 8.24074 8.17555 1 16.9846 1C25.7936 1 33 8.24074 33 17.1727C33 21.6387 32.9459 26.9109 24.5066 35.3944L16.9846 43Z",
    fill: "#2BDACD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 44C19.7614 44 22 43.5523 22 43C22 42.4477 19.7614 42 17 42C14.2386 42 12 42.4477 12 43C12 43.5523 14.2386 44 17 44Z",
    fill: "black"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9846 0.75C12.5084 0.75 8.44736 2.5903 5.50641 5.56586C2.56968 8.53715 0.75 12.6405 0.75 17.1727C0.75 21.6803 0.795273 27.0052 9.31617 35.5707L16.9842 43.3559L25.0461 35.2034C32.4888 27.5855 33.1776 22.5573 33.2433 18.3615L33.25 17.1741C33.25 12.6426 31.4243 8.54094 28.4822 5.56992C25.5332 2.59196 21.4627 0.75 16.9846 0.75Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9846 1.5C12.7162 1.5 8.84411 3.25581 6.03983 6.09308C3.2365 8.92941 1.5 12.8465 1.5 17.1727C1.5 21.5554 1.57196 26.7225 9.84788 35.0418L16.9853 42.2882L24.5128 34.676C31.7261 27.2928 32.4296 22.4239 32.4934 18.3498L32.5 17.1699C32.5 12.8487 30.7576 8.93354 27.9493 6.09766C25.137 3.25772 21.2554 1.5 16.9846 1.5Z",
    stroke: "#233459",
    strokeOpacity: 0.35
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17.0001,
    r: 8.25252,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -5,
    width: 44,
    height: 44,
    fill: "#A5F0EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5 -1.33337H0.499959C-0.512563 -1.33337 -1.33337 -0.512563 -1.33337 0.499959V33.5C-1.33337 34.5125 -0.512563 35.3333 0.499959 35.3333H33.5C34.5125 35.3333 35.3333 34.5125 35.3333 33.5V0.499959C35.3333 -0.512563 34.5125 -1.33337 33.5 -1.33337ZM31.6666 9.66664H28V13.3333H31.6666V17H28V20.6666H31.6666V24.3333H28V28H31.6666V31.6666H28V28H24.3333V31.6666H20.6666V28H17V31.6666H13.3333V28H9.66664V31.6666H5.99998V28H2.33331V24.3333H5.99998V20.6666H2.33331V17H5.99998V13.3333H2.33331V9.66664H5.99998V5.99998H2.33331V2.33331H5.99998V5.99998H9.66664V2.33331H13.3333V5.99998H17V2.33331H20.6666V5.99998H24.3333V2.33331H28V5.99998H31.6666V9.66664ZM5.99994 24.3333V28H9.66661V24.3333H5.99994ZM9.66663 20.6667V24.3334H13.3333V20.6667H9.66663ZM13.3333 16.9999V20.6666H17V16.9999H13.3333ZM16.9999 17H20.6666V13.3333H16.9999V17ZM20.6666 13.3334H24.3333V9.6667H20.6666V13.3334ZM24.3333 5.99994V9.66661H28V5.99994H24.3333ZM13.3333 24.3333V28H17V24.3333H13.3333ZM16.9999 20.6667V24.3334H20.6666V20.6667H16.9999ZM20.6666 20.6666H24.3333V16.9999H20.6666V20.6666ZM24.3333 17H28V13.3333H24.3333V17ZM20.6666 24.3333V28H24.3333V24.3333H20.6666ZM24.3333 24.3334H28V20.6667H24.3333V24.3334ZM9.66661 16.9999H5.99994V20.6666H9.66661V16.9999ZM13.3333 13.3333H9.66663V17H13.3333V13.3333ZM17 13.3334V9.6667H13.3333V13.3334H17ZM20.6666 9.66661V5.99994H16.9999V9.66661H20.6666ZM9.66661 9.6667H5.99994V13.3334H9.66661V9.6667ZM13.3333 9.66661V5.99994H9.66663V9.66661H13.3333Z",
    fill: "#000A19",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 8,
    y: 38,
    width: 18,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnLocationMarker);
export default __webpack_public_path__ + "static/media/return-location-marker.fb9916389de095a75d4b7d3ed2a1a6ed.svg";
export { ForwardRef as ReactComponent };